import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { installStaleChunkRecovery } from './lib/staleChunk'
import './index.css'

// Before the first render, so a route chunk that dies on the very first
// navigation is already covered.
installStaleChunkRecovery()

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root is missing from index.html')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
